import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"

export function HowWeGotScoreSection() {
  const steps = [
    {
      title: "Aggregate",
      description: `We track down every review on the internet.`,
      detail: `No cherry-picking — we use the full picture. Our team carefully audits each review to ensure it is legitimate and relevant.`,
    },
    {
      title: "Weight",
      description:
        "We consider each review based on how useful it is for new customers.",
      detail:
        "Reviews from verified customers, long-term owners, and recent projects are up-weighted. Reviews that are empty, from shoppers who never hired the company, or flagged as unfair are down-weighted.",
    },
    {
      title: "Analyze",
      description: "We look for five signals of work quality in each review.",
      detail:
        "Every review is scored across five dimensions: sales conduct, workmanship, project management, post-sale support, and value. This gives a detailed picture beyond a single star rating.",
    },
    {
      title: "Screen",
      description: "We look for other signals not captured by star ratings.",
      detail:
        "We check how long the company has been in business, their BBB rating, whether their review patterns look natural, and if they hold a valid contractor license.",
    },
    {
      title: "Score",
      description:
        "We combined all the signals into a single trust score from 0 to 100.",
      detail:
        "The weighted review analysis, screening signals, and work quality scores are combined into one number that represents how much you can trust this company to deliver a good experience.",
    },
    {
      title: "Rank",
      description:
        "We benchmarked this company against every other in the market.",
      detail:
        "Each trust score is compared against all other solar companies serving your area, so you can see exactly where this installer stands relative to the competition.",
    },
  ]

  return (
    <Accordion type="single" collapsible>
      {steps.map((step, i) => {
        const number = String(i + 1).padStart(2, "0")
        return (
          <AccordionItem
            key={number}
            value={`step-${number}`}
            className="group"
          >
            <AccordionTrigger className="p-0">
              <div className="flex">
                <div className="border-border flex w-16 shrink-0 items-center justify-center border-r-2 text-lg font-black transition-colors sm:w-20 sm:text-xl md:w-28 md:text-2xl">
                  {number}
                </div>
                <div className="p-3 sm:p-4 md:p-6">
                  <div className="wb-h6">{step.title}</div>
                  <div className="wb-label-muted mt-1">{step.description}</div>
                </div>
              </div>
            </AccordionTrigger>
            <AccordionContent className="bg-muted ml p-3 sm:p-4 md:p-6">
              {step.detail}
            </AccordionContent>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}
